import {
  PartyDto,
  QuestionnaireFieldIdentity,
  QuestionnaireFieldType,
} from '@g2-shared/api-client/generated/onboarding-app';
import { generateFieldInfoByIdentity } from '../../../questionnaire';
import {
  generateQuestionnaireFilledFieldFormFromDto,
  QuestionnaireFilledFieldForm,
} from '../../../questionnaireFilled';

export interface PartyForm {
  partyTypeId?: number;
  questionnaireSetId?: number;
  userId: string;
  entityFields: QuestionnaireFilledFieldForm[];
  password?: string;
  confirmationPassword?: string;
  subServiceCode?: string;
}

export const generateEmptyPartyForm = (): PartyForm => ({
  partyTypeId: undefined,
  entityFields: [],
  userId: '',
  subServiceCode: '',
});

const mandatoryFields = [
  QuestionnaireFieldIdentity.firstName,
  QuestionnaireFieldIdentity.lastName,
  QuestionnaireFieldIdentity.personalId,
  QuestionnaireFieldIdentity.dateOfBirth,
  QuestionnaireFieldIdentity.placeOfBirth,
  QuestionnaireFieldIdentity.countryOfBirth,
  QuestionnaireFieldIdentity.citizenship,
  QuestionnaireFieldIdentity.mobileNumber,
  QuestionnaireFieldIdentity.email,

  QuestionnaireFieldIdentity.companyName,
  QuestionnaireFieldIdentity.tradeName,
  QuestionnaireFieldIdentity.companyRegistrationNumber,
  QuestionnaireFieldIdentity.taxNumber,
];

export const generateQuestionnaireFilledFieldFromFromIdentity = (
  identity: QuestionnaireFieldIdentity,
  position: number,
  defaultValue?: string
): QuestionnaireFilledFieldForm => {
  const fieldInfo = generateFieldInfoByIdentity(identity);

  return {
    identity,
    value: defaultValue ?? '',
    fieldType: fieldInfo.fieldType as QuestionnaireFieldType,
    fieldInfo,
    questionnaireFieldId: 0,
    name: identity,
    ownershipItems: [],
    availableItems: [],
    comment: '',
    hasComment: false,
    mandatory: mandatoryFields.includes(identity),
    position,
    disabled: !!defaultValue,
  };
};

export const generatePartyFormFromDto = (dto: PartyDto): PartyForm => ({
  partyTypeId: dto.partyTypeId,
  entityFields: dto.entityFields.map((f) => generateQuestionnaireFilledFieldFormFromDto(f)),
  userId: '',
  subServiceCode: '',
});
